import { ParamMap } from '@angular/router';
import {
    MONITORING_ENVIRONMENT_ID,
    MONITORING_FQN,
    MONITORING_INCLUDE_SUBFOLDERS,
    MONITORING_ROBOT_TYPE,
    MONITORING_TIME_FRAME,
} from '@utils/queryParam.utils';

export const DEFAULT_TIME_FRAME = 60 /* hour */ * 24 /* day */;

export interface IMonitoringQueryOptions {
    includeSubfolders?: boolean;
    timeFrameMinutes: number;
    environmentId?: number;
    robotType?: number;
    fqn?: string;
}

export interface IMonitoringErrorLogsOptions {
    afterId?: number;
    beforeId?: number;
}

export const filterParamExtractor = (params: ParamMap): IMonitoringQueryOptions => {
    return {
        includeSubfolders: params.get(MONITORING_INCLUDE_SUBFOLDERS) == null ?
            undefined :
            params.get(MONITORING_INCLUDE_SUBFOLDERS) === 'true',
        timeFrameMinutes: params.get(MONITORING_TIME_FRAME) == null ?
            DEFAULT_TIME_FRAME :
            Number(params.get(MONITORING_TIME_FRAME)),
        environmentId: params.get(MONITORING_ENVIRONMENT_ID) == null ?
            undefined :
            Number(params.get(MONITORING_ENVIRONMENT_ID)),
        robotType: params.get(MONITORING_ROBOT_TYPE) == null ?
            undefined :
            Number(params.get(MONITORING_ROBOT_TYPE)),
        fqn: params.get(MONITORING_FQN) == null ?
            undefined :
            params.get(MONITORING_FQN)!,
    };
};
